import { endOfYear, format, startOfYear, subYears } from "date-fns";

export const fuelTypeOptions = [
  "gasoline",
  "diesel",
  "electric",
  "hybrid",
  "cng",
  "lpg",
];

export const statusOptions = [
  { value: "available", label: "Available" },
  { value: "in_use", label: "In Use" },
  { value: "maintenance", label: "Maintenance" },
  { value: "out_of_service", label: "Out of Service" },
  { value: "retired", label: "Retired" },
];

export const driverFullname = (driver) => {
  const { employee } = driver;
  if (employee) {
    let { employee } = driver;
    return `${employee.Title} ${employee.Name}`;
  }
  return driver.employee_id;
};

const ones = [
  "",
  "One",
  "Two",
  "Three",
  "Four",
  "Five",
  "Six",
  "Seven",
  "Eight",
  "Nine",
];

const teens = [
  "Ten",
  "Eleven",
  "Twelve",
  "Thirteen",
  "Fourteen",
  "Fifteen",
  "Sixteen",
  "Seventeen",
  "Eighteen",
  "Nineteen",
];

const tens = [
  "",
  "",
  "Twenty",
  "Thirty",
  "Forty",
  "Fifty",
  "Sixty",
  "Seventy",
  "Eighty",
  "Ninety",
];

function numberToWords(num) {
  if (num === 100) return "One Hundred";

  if (num < 10) return ones[num];

  if (num < 20) return teens[num - 10];

  const ten = Math.floor(num / 10);
  const one = num % 10;

  return one === 0 ? tens[ten] : `${tens[ten]} ${ones[one]}`;
}

export const paymentTerms = Array.from({ length: 100 }, (_, i) => {
  const number = i + 1;
  const word = numberToWords(number);

  return {
    label: `${word} Installment${number > 1 ? "s" : ""}`,
    value: number,
  };
});

export const MODE_OPTIONS = [
  { value: "", label: "None" },
  { value: "yoy", label: "Year on Year" },
  { value: "mom", label: "Month on Month" },
  { value: "qoq", label: "Quarter on Quarter" },
  { value: "wow", label: "Week on Week" },
];

export const getOrdinalSuffix = (n) => {
  const j = n % 10;
  const k = n % 100;
  if (j === 1 && k !== 11) return "st";
  if (j === 2 && k !== 12) return "nd";
  if (j === 3 && k !== 13) return "rd";
  return "th";
};

export function getDefaultThreeYearRange(dateFormat = "yyyy-MM-dd") {
  const end = new Date();
  const start = subYears(end, 2);
  const startYear = startOfYear(start);
  const endYear = endOfYear(end);

  return {
    startDate: format(startYear, dateFormat),
    endDate: format(endYear, dateFormat),
  };
}
